import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import UserSearch from "../components/UserSearch";

export default function SearchPage() {
  const nav = useNavigate();
  return (
    <div className="px-4 py-6">
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => nav(-1)} data-testid="search-back" className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center active:scale-90">
          <ArrowLeft className="w-4 h-4"/>
        </button>
        <h1 className="font-outfit font-extrabold text-2xl tracking-tighter">Find People</h1>
      </div>
      <p className="text-white/60 text-sm mb-3">Search creators, streamers and friends by name, @username or email.</p>
      <UserSearch autoFocus placeholder="Search users..." />
    </div>
  );
}
